import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import NavTabs from "../../components/NavTabs";
import Sidebar from "../../components/SideBar";
import List from "../../components/List";
import Label from "../../components/Label";
import Button from "../../components/Button";
import tableIcons from "../../config/tableIcons";
// import Register from "./Register";

import { Line } from "./styles";
import Event from "../../services/event";

const Leads = (props) => {
    const [open, setOpen] = useState(false);
    const history = useHistory();

    const columns = [
        { field: "people.name", title: "Nome" },
        { field: "people.email", title: "Email" },
        { field: "people.cpf", title: "Documento" },
        { field: "people.role", title: "Categoria" },
        { field: "registered_at", title: "Registrado na Atividade" },
    ];

    const actions = [];

    const getRows = () => {
        return Event.getLeadsByActivity(props.computedMatch?.params?.activity_id)
            .then((resp) => {
                console.log(resp);
                if (!!resp.data && !!resp.data.data)
                    return resp.data.data.leads.map((lead) => {
                        return {
                            ...lead,
                            registered_at: new Date(lead.registered_at).toLocaleString(),
                        };
                    });
                return [];
            })
            .catch(function (error) {
                return [];
            });
    };

    const data = [
        {
            name: "Participantes",
            content: <List columns={columns} rows={[]} getRows={getRows} actions={actions} />,
        },
    ];

    const handleOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };

    const page = (
        <>
            <Line>
                <Label className="first" size="min" color="dark" align="left" weight="500">
                    Participantes
                </Label>
            </Line>
            {/* <Dialog open={open} onClose={handleClose}>
                <DialogContent>
                    <Register close={handleClose} />
                </DialogContent>
            </Dialog> */}
            <div style={{ maxWidth: "100%" }}>
                <NavTabs itens={data} />
            </div>
        </>
    );

    return <Sidebar current="Atividades" content={page} />;
};

export default Leads;
